import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const base =
  'w-full rounded-lg bg-background/50 border border-border text-foreground placeholder-muted-foreground focus:border-primary focus:outline-hidden focus:ring-2 focus:ring-primary/20 transition-colors';

const sizes = {
  sm: 'px-3 py-2 text-sm',
  md: 'px-4 py-3 text-sm',
} as const;

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  inputSize?: keyof typeof sizes;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, inputSize = 'md', ...props }, ref) => {
  return <input ref={ref} className={cn(base, sizes[inputSize], className)} {...props} />;
});
Input.displayName = 'Input';
